export enum SyncControlState {
  LOADING = 'LOADING',
  LOAD_ERROR = 'LOAD_ERROR',
  READY = 'READY'
}

export enum SyncControlDatasourceState {
  NOT_CONNECTED = 'NOT_CONNECTED',
  PENDING_SETUP = 'PENDING_SETUP',
  RECONNECTING = 'RECONNECTING',
  SYNCING = 'SYNCING',
  SYNC_FAILED = 'SYNC_FAILED',
  SYNC_COMPLETE = 'SYNC_COMPLETE'
}

export enum SyncControlVariant {
  INLINE = 'inline',
  SIDEBAR = 'sidebar'
}
